module.exports = __webpack_public_path__ + "static/img/ad-10.b35fb05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad-10.png
// module id = anTu
// module chunks = 0